export default apiFetch => async payload => {
  const response = await apiFetch({
    endpoint: "request-gated-file",
    method: "post",
    body: payload
  });

  return await response.json();
};
